export const environment = {
  version: "997-manual",
  production: true,
  region: "ap-southeast-2",
  endpoint: "https://api.uat.surveyor.digitalp.com.au",
  logLevel: "silly",
  buildId: process.env.NG_APP_BUILD_ID || "local",
  defaultCollectionLimit: 10,
  enableServiceWorker: true,
  enableSentry: true,
  sentryEnvironment: "uat",
  sentryTracesSampleRate: 0.1,
  sentryReplayMaskAllText: false,
  sentryReplayMaskAllInputs: false,
  sentryReplayBlockAllMedia: false,
  sentryReplaySessionSampleRate: 0,
  sentryReplayOnErrorSampleRate: 1,
  timeZone: "Australia/Brisbane",
  defaultAuthEmail: "",
  defaultAuthPassword: "",
  defaultDateFormat: "dd MMM yyyy hh:mma",
  defaultShortDateFormat: "dd/MM/yyyy",
  siteDomain: "uat.surveyor.digitalp.com.au",
  secureCookies: true,
  featureFlags: {
    versionChecking: true,
  },
};
